import styled from 'styled-components';

export const StyledProgressLoader = styled.div`
  width: 100vw;
  height: calc(100vh);
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(36, 41, 47, 0.4);
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 10000;

  input {
    display: none;
  }

  label {
    position: relative;
    display: block;
    width: 60%;
    height: 20px;
    background: transparent;
    border-radius: 50px;
    border: 1px solid white;
    overflow: hidden;
    display: flex;
    justify-content: center;

    div {
      position: absolute;
      top: 0;
      left: 0;
      background: #fdbc09;
      height: 100%;
      width: ${({ progress }) => progress}%;
      box-shadow: 0 0 8px 1px white inset;
    }
  }

  span {
    display: inline-block;
    color: #000;
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    font-weight: 700;
    margin-top: 12px;

    &:last-child {
      float: right;
    }
  }
`;
